export class AnalyticsEvents {
  public static eventName = {
    INTERACTION_MAPS_CREATE: 'Interaction_Map_create',
    INTERACTION_MAPS: 'Interaction_Maps',
    INTERACTION_MAPS_DETAILS_ADD_INTERACTION_ICON: 'Interaction_Maps_Details_Add_interaction_icon',
    INTERACTION_MAPS_DETAILS_ADD_INTERACTION: 'Interaction_Maps_Details_Add_interaction',
    INTERACTION_MAPS_DETAILS_ADD_INTERACTION_TEMPLATE: 'Interaction_Maps_Details_add_interaction_template',
    INTERACTION_MAPS_DETAILS_ADD_INTERACTION_CONFIG_SET: 'Interaction_Maps_Details_add_interaction_ConfigSet',
    INTERACTION_MAPS_DETAILS_USER_SPLIT: 'Interaction_Maps_Details_User_split',
    INTERACTION_MAPS_DETAILS_USER_SPLIT_AB_TEST: 'Interaction_Maps_Details_User_split_ABTest',
    INTERACTION_MAPS_DETAILS_USER_SPLIT_SEGMENT: 'Interaction_Maps_Details_User_split_segment',
    INTERACTION_MAPS_DETAILS_USER_SPLIT_ROLLOUT: 'Interaction_Maps_Details_User_split_rollout',
    INTERACTION_MAP_SETTINGS: 'Interaction_Map_Settings',
    INTERACTION_MAPS_BRANCH_RESULT: 'Interaction_Maps_Details_Results_Click',
    INTERACTION_MAPS_NODE_RESULT: 'Interaction_Maps_Details_SplitterResults_Click',
    INTERACTION_MAPS_NUDGE_RESULT: 'Interaction_Maps_Details_NudgeResults_Click',
    INTERACTION_MAPS_DETAILS_NUDGE_RESULTS_SELECT_NUDGE: 'Interaction_Maps_Details_NudgeResults_SelectNudge',
    CONFIG_SET_CREATE: 'Config_Set_Create',
    CONFIG_ADD_ICON: 'Config_add_icon',
    CONFIG_CREATE: 'Config_Create',
    BILLING_PLAN_VIEW: 'Billing_plan_view',
    ADD_INTERACTION_ICON: 'add_interaction_Icon',
    ADD_INTERACTION_TEMPLATE: 'Add_Interaction_template',
    UM_INVITE: 'um_invite',
    APPS_CREATE: 'apps_create',
    APP_SETTINGS: 'apps_settings',
    INTERACTION_MAPS_VIEW: 'interaction_maps_view',
    SEGMENT_CREATE: 'segment_create',
    SEGMENT_EDIT: 'segment_edit',
    ADD_TEST_DEVICE: 'test_devices_add_devices',
    HOMEPAGE_VIEW: 'homepage_view',
    HOMEPAGE_MENU_CLICK: 'homepage_menu_click',
    HOMEPAGE_INVITE_MEMBER: 'homepage_invite_member',
    HOMEPAGE_CREATE_APP: 'homepage_create_app',
    LEFT_PANEL_MENU_CLICK: 'left_panel_menu_click',
    TEMPLATES_VIEW: 'templates_view',
    SEGMENTS_VIEW: 'segments_view',
    CONFIG_SETS_VIEW: 'config_sets_view',
    APPS_VIEW: 'apps_views',
    TEST_DEVICE_VIEW: 'test_devices_view',
    UM_VIEW: 'um_view',
    BILLING_MANAGEAPPS_CLICK: 'Billing_manageapps_click',
    BILLING_PAYMENT_INFO: 'Billing_payment_info',
    BILLING_GETPRO_CLICK: 'Billing_getpro_click',
    BILLING_UPDATE_CONTRACT: 'Billing_update_contact',
    BILLING_VIEW_INVOICE: 'Billing_view_invoice',
    APP_UPGRADE: 'App_Upgrade',
    APP_DOWNGRADE: 'App_Downgrade',
    BILLING_PAGE_CLICK: 'Billing_Page_Click'
  };
  public static eventAction = {
    CREATE: 'create',
    CONTINUE_CREATE: 'continue_create',
    CREATE_FINISH: 'create_finish',
    CREATE_DONE: 'create_done',
    CREATE_CANCEL: 'create_cancel',
    UPDATE: 'update',
    ACTIVATE: 'Activate',
    DEACTIVATE: 'Deactivate',
    PAGE_VIEW: 'page_view',
    ADD_INTERACTION_CLICK: 'add_interaction_click',
    ADD_INTERACTION_CLICK_TEMPLATES: 'add_interaction_click_templates',
    ADD_INTERACTION_CLICK_CONFIG_SET: 'add_interaction_click_ConfigSet',
    RESULTS_CLICK_BRANCH: 'results_view',
    RESULTS_CLICK_NODE: 'node_result_view',
    RESULTS_CLICK_NUDGE: 'nudge_result_view',
    TEMPLATES_SELECTION: 'template_selection',
    TEMPLATE_DONE: 'template_done',
    AB_TEST: 'AB_test',
    Rollout: 'Rollout',
    UserSegment: 'UserSegment',
    AB_TEST_DONE: 'AB_test_done',
    SELECT_USER_SEGMENT: 'Select_UserSegment',
    ROLLOUT_DONE: 'Rollout_done',
    ATTACH_GOALS: 'attach_goals',
    ADD_CONFIG_SET_CREATE: 'add_configSet_create',
    ADD_CONFIG_SET_SAVE: 'add_configSet_save',
    SUCCESS_CALL_BACK: 'success_call_back',
    ADD_CLICK: 'add_click',
    CREATE_CLICK: 'create_click',
    ADD_DEVICE: 'add_click',
    ADD_DEVICE_DIALOG: 'continue',
    CREATE_SUBMIT: 'create_submit',
    CANCEL: 'cancel',
    SUCCESS_CALLBACK: 'successcallback',
    INVITE: 'invite',
    SAVE: 'update_save',
    INVITE_SUBMIT: 'invite_submit',
    GO_TO_DOCS: 'go_to_docs',
    INVITE_DEVELOPER: 'invite_developer',
    CLICK_ON_DATA_SOURCES: 'click_on_data_sources',
    ONBOARD: 'onboard',
    PRO: 'pro',
    ADVANCED: 'advanced',
    RESULTS_VIEW: 'results_view',
    AB_RESULTS: 'ab_result',
    ROLLOUT_RESULTS: 'rollout_result',
    SEGMENT_RESULT: 'segment_result',
    NUDGE_RESULTS_VIEW: 'nudge_result_view',
    SELECT_NUDGE: 'select_nudge',
    UPGRADE_CLICK: 'upgrade_click',
    UPGRADE_SUCCESS: 'upgrade_success',
    UPGRADE_FAIL: 'upgrade_fail',
    DOWNGRADE_CLICK: 'downgrade_click',
    DOWNGRADE_SUCCESS: 'downgrade_success',
    DOWNGRADE_FAIL: 'downgrade_fail',
    HANSEL_ONBOARD: 'Hansel_Onboard',
    HANSEL_OPTIMIZE: 'Hansel_Optimize'
  };
  public static analyticsCtaMap = {
    im: 'interactionMaps',
    temps: 'templates',
    cs: 'config_set',
    apps: 'apps',
    segs: 'user_segment',
    ds: 'data_source',
    tgs: 'test_devices',
    um: 'user_management',
  };
}
